/**
 * Dashboard Constants
 *
 * This file contains constants used throughout the Dashboard feature.
 */

// Maximum allowed Data Interval last four hours
export const DEFAULT_DATA_WINDOW_HOURS = 4
export const DEFAULT_DATA_PERFORMANCE_WINDOW_HOURS = 1
